import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { Globals } from 'src/classes/global';
import { Product } from 'src/classes/product';
import { VoceMenu } from 'src/classes/voce-menu';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  // La risposta (solo metadati + URL statici) è condivisa via shareReplay tra
  // prefetch e carosello; la cache vera sta lato API (RAM + SQL).
  private banner$: Observable<any[]> | null = null;
  private bannerCulture: string | null = null;

  constructor(protected http: HttpClient,
    protected global: Globals) { }

  getProductTop(): any {
    return this.http.get<Product[]>(environment.api + "api/navigation/top");
  }

  sendEmail(form: any) {
    return this.http.post(environment.api + "api/navigation/contact", form);
  }

  getMenu(): any{
    return this.http.get<VoceMenu>(environment.api + "api/navigation/menu");
  }

  getBanner(): Observable<any[]> {
    const culture = this.getCulture();

    if (this.banner$ && this.bannerCulture === culture) {
      return this.banner$;
    }

    this.banner$ = this.http.get<any[]>(environment.api + "api/navigation/banner").pipe(
      tap({
        error: () => { this.banner$ = null; }
      }),
      shareReplay(1)
    );

    this.bannerCulture = culture;
    return this.banner$;
  }

  getStoreLocator(lat:number, lng:number, distance:number): any {
    var url = environment.api + "api/navigation/storelocator/" + lat + "/" + lng + "/" + distance;

    return this.http.get(url);
  }

  getNews(): any {
    return this.http.get(environment.api + "api/navigation/news");
  }

  getNewsDetails(idNews:number): any {
    return this.http.get(environment.api + "api/navigation/news/detail/" + idNews);
  }

  getCatalogs(): any {
    return this.http.get(environment.api + "api/navigation/catalogs");
  }

  // Stessa logica del TokenInterceptor: la lingua è il primo segmento del path.
  private getCulture(): string {
    const urllang = location.pathname.split('/')[1];
    return urllang != "" && urllang != undefined ? urllang : this.global.culture;
  }
}
